import * as React from 'react';
import { useHeaderBundle } from 'src/providers/PantherLocalizationProvider';
import { AccountDropdownAccountName } from './styles';

const ACCOUNT_NAME_MAX_DISPLAY_LENGTH = 50;
const ACCOUNT_NAME_FOLLOW_UP_STRING = '...';

interface AccountNameValueProps {
  isMobile?: boolean;
  accountName?: string;
}

const AccountNameValue: React.VFC<AccountNameValueProps> = ({
  isMobile,
  accountName,
}) => {
  const bundle = useHeaderBundle();
  let value = accountName;

  // show no accounts selected if account name is not defined
  if (!value) {
    value = bundle.getMessage('no-accounts-selected');
  } else if (value.length > ACCOUNT_NAME_MAX_DISPLAY_LENGTH && !isMobile) {
    // truncate account name if it exceeds max account name display and in mobile view
    value = value
      .substring(0, ACCOUNT_NAME_MAX_DISPLAY_LENGTH)
      .concat(ACCOUNT_NAME_FOLLOW_UP_STRING);
  }

  return <AccountDropdownAccountName>{value}</AccountDropdownAccountName>;
};

export default AccountNameValue;
